import ReactQuill from 'react-quill-new';
import { QUILL_PRESETS, QUILL_FORMATS_FULL } from './_quillPresets';

const BLOCK = 'LStudio__app_rte';

/*
    🔥 EDITOR — Quill

    Un solo componente con tres barras. El motor y el CSS son los
    mismos: cambia qué se le ofrece al usuario.

    ⚠️ Su CSS (quill.snow.css) se importa UNA vez en App.js, antes que
       el nuestro. Los overrides van en RichText.css.

    Guarda HTML. Sanitizalo en el backend antes de mostrarlo.
*/

export const RichTextQuill = ({
    value, onChange, placeholder, preset = 'basic',
    isDisabled = false, minHeight = 160, ...rest
}) => (

    <div className={`${BLOCK} ${BLOCK}--quill`} data-preset={preset}
        style={{ '--LS__rte_min_height': `${minHeight}px` }} >

        <ReactQuill
            theme="snow"
            value={value ?? ''}
            onChange={onChange}
            placeholder={placeholder}
            modules={QUILL_PRESETS[preset] ?? QUILL_PRESETS.basic}
            formats={preset === 'full' ? QUILL_FORMATS_FULL : undefined}
            readOnly={isDisabled}
            {...rest}
        />

    </div>
);
